export default function generateActions(action: string) {
  const standardizedName = action.toUpperCase()
  return {
    REQUEST: `${standardizedName}_REQUEST`,
    SUCCESS: `${standardizedName}_SUCCESS`,
    FAILURE: `${standardizedName}_FAILURE`
  }
}
